export interface PressArticle {
  id: number;
  year: string;
  publication: string;
  type: 'article' | 'book' | 'podcast';
  title: string;
  description: string;
  url?: string;
}

export const pressArticles: PressArticle[] = [
  {
    id: 1,
    year: '2026',
    publication: 'CXO Dispatch',
    type: 'article',
    title: 'Jeff Dumé: Reducing Hiring Risk Through Structured Evaluation & Responsible AI Use',
    description:
      'Discussed how structured evaluation and responsible AI can help organizations improve hiring outcomes while preserving human judgment.',
  },
  {
    id: 2,
    year: '2026',
    publication: 'Voyage Houston',
    type: 'article',
    title: 'Exploring Life & Business with Jeff Dumé of Mainframe Solutions',
    description:
      'Shared lessons on entrepreneurship, growth, and building organizations through relationships, systems, and long-term thinking.',
  },
  {
    id: 3,
    year: '2026',
    publication: 'Regional Hispanic Contractors Association',
    type: 'article',
    title: 'OSHA Safety & AI Roundtable',
    description:
      'Industry discussion focused on the role of AI, safety culture, and operational leadership in modern construction environments.',
  },
  {
    id: 4,
    year: '2023',
    publication: 'CanvasRebel',
    type: 'article',
    title: 'Building a One-Stop Operational Support Business',
    description:
      'Spoke on building a one-stop operational support business focused on recruitment, business development, operational structure, and scalable solutions across construction, finance, and growing organizations.',
    url: 'https://canvasrebel.com/meet-jeff-dume/',
  },
  {
    id: 5,
    year: '2022',
    publication: 'Shoutout HTX',
    type: 'article',
    title: 'Early Perspectives on Entrepreneurship',
    description:
      'Shared early perspectives on entrepreneurship, persistence, operational problem solving, and helping organizations simplify growth through recruiting, partnerships, systems, and business infrastructure.',
  },
  {
    id: 6,
    year: '2022',
    publication: 'Voyage Houston',
    type: 'article',
    title: 'Taking Risks & Building Independently',
    description:
      'Discussed taking risks, relocating to Houston independently, and building a career through recruiting, business development, networking, and operational growth across multiple industries.',
  },
  {
    id: 7,
    year: '',
    publication: 'From $0 to $500K',
    type: 'book',
    title: "A RECRUITER'S JOURNEY TO GROWTH AND EXCELLENCE",
    description:
      "A recruiter's journey through business development, recruiting, operational discipline, systems thinking, and building scalable growth without outside investment.",
  },
  {
    id: 8,
    year: '',
    publication: 'Podcast Feature',
    type: 'podcast',
    title: 'Conversations on Workforce & Growth',
    description:
      'Conversations focused on workforce infrastructure, executive search, AI-assisted hiring systems, operational efficiency, entrepreneurship, and the future of organizational growth.',
  },
];